export default __webpack_public_path__ + "img/health-insurance.c01dc403.png";